import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './PmorderAPI';
import {getColumns} from './PmorderStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getPmorderView} from './PmorderView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deletePmorderObj  ,setSelectedPmorderId,setSelectedActionId , setShowEditForPmorder} from 'store/slice/PharmaSlice';

import PmorderListTable from './components/PmorderListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import PmorderFilterCriteria from './PmorderFilterCriteria';




import { transformDateValue } from 'core/js/FormUtils';

export default function PmorderListImpl( {tableList, cardList, setShowEdit, setPmorderId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, pmorderObj} = useSelector((state)=>state.pharmaslice.pmorderDashboard);
  const { pmorderList } = useSelector((state) => state.pharmaslice.pmorderDashboard);
  const {productObj} = useSelector((state) => state.pharmaslice.productDashboard);

  useEffect(() => {
  }, [pmorderList, pmorderObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedPmorderId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deletePmorderObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedPmorderId(id));
    dispatch(setShowEditForPmorder(true));
  }
  
  const createPmorder=()=>{
    dispatch(setSelectedPmorderId(-1));
    dispatch(setShowEditForPmorder(true));
  }



const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,
		'orderdate': transformDateValue(data.orderdate),
		'receivedon': transformDateValue(data.receivedon)
    }
    return newData;
  }
  const pmorderTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    pmorderList:pmorderList,
    cardList:getPmorderView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:pmorderTransformation(tableList),
      pmorderList:pmorderList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'} sx={{height:showfilter?'55px':'35px'}}>
                      <Grid item  lg={8}>
                        <Typography variant='h4' color="primary.darker">Packaging Material Order</Typography>
                      </Grid>
                      <Grid container lg={4} justifyContent={'flex-end'} alignItems={'center'} sx={{pb:2}}>
                      
                              <Tooltip title="Add Pmorder" sx={{ cursor: "pointer" }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  startIcon={<AddIcon />}
                                  onClick={() => { createPmorder() }}
                                  sx={{ minWidth: 0, fontWeight: 600, textTransform: "none" }}
                                  disabled={productObj.designstatus==='AVAILABLE'?true:false}
                                >
                                  Add Material
                                </Button>
                              </Tooltip>
                        </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                < PmorderListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
    </>
);


}